var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',_vm._b({attrs:{"label":"Generate","color":"accent","disable":!_vm.isGranted('GENERATE_REPORT')},on:{"click":_vm.open}},'q-btn',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }